import { Reveal, SectionHeading } from "@/components/landing/primitives";
import { TECH_STACK } from "@/data/content";

export default function TechStack() {
  return (
    <section id="tech" className="relative py-20 md:py-28 scroll-mt-24" data-testid="section-tech">
      <div className="container-trt">
        <SectionHeading
          eyebrow="Technology Stack"
          title="Engineered on proven"
          highlight="Web3 infrastructure"
          sub="TRT is built on battle-tested, open standards — EVM compatibility, decentralized storage, oracles and machine learning."
        />

        <div className="mt-14 flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {TECH_STACK.map((t, i) => (
            <Reveal key={t} delay={i * 0.04}>
              <span
                className="inline-block glass rounded-full px-5 py-2.5 text-sm font-mono text-[var(--muted)] hover:text-[var(--gold-2)] card-hover cursor-default"
                data-testid={`tech-${t.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
              >
                {t}
              </span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
